// we need this till we have Store types from the Core
export const AUTH_STATE = 'authentication';

export interface AuthStateSlice {
  accessToken: string | undefined;
  user?: User | null;
  accounts: UserProfileAccount[];
}

export interface User {
  country: string | undefined;
  id: string;
}

export type TokenInfo = {
  sub: string;
  metadata: Metadata;
};

export type Metadata = {
  permissions?: string[];
  platforms?: string[];
  lpvid?: string;
};

export interface UserProfileAccount {
  logistic_vendor_id: string;
  global_entity_id: string;
  vendor_id: string;
  address: {
    country: {
      code: string;
    };
  };
  delivery_types: string[];
}
